import { Component } from "react";
import LayoutPublico from "../../componentes/Comunes/Layout/LayoutPublico";

class NoAutorizado extends Component {
  state = {};
  render() {
    return (
      <LayoutPublico>
        <h1 className="h1 text-gray-900">Sin Autorización</h1>
        <p className="lead text-gray-800">
          Requiere autorización para acceder a esta página o recurso.
        </p>
        <button
          className="btn btn-primary btn-icon-split text-center"
          onClick={this.props.history.goBack}
        >
          <span className="icon text-white-50">
            <i className="fas fa-arrow-alt-circle-left"></i>
          </span>
          <span className="text">Regresar</span>
        </button>
      </LayoutPublico>
    );
  }
}

export default NoAutorizado;
